export const documentType = {
  banner: 'BANNER',
  CAROUSEL_VERTICAL: 'CAROUSEL_VERTICAL',
  profilePicture: 'profile_picture',
  info: 'INFO',
  carouselVertical: 'CAROUSEL_VERTICAL',
  carouselHorizontal: 'CAROUSEL_HORIZONTAL',
};
export const documentFormat = {
  quill: 'quill',
};

export class DocumentProperties {
  constructor(format, displayName, photo, order, originalFileName) {
    this.format = format;
    this.displayName = displayName;
    this.photo = photo;
    this.order = order;
    this.originalFileName = originalFileName;
  }
}
const defaultProperties = new DocumentProperties(null, null, null, null);
export default class Document {
  constructor(id, docType, properties = defaultProperties, url, fileSize) {
    this.id = id;
    this.documentType = docType;
    this.properties = properties;
    this.url = url;
    this.uploadDate = null;
    this.fileSize = fileSize;
  }
}
